import { Node_Type } from "./../../ricos-types/index.js";
import Divider from "./divider.js";
const nodeViewRenderers = {
  [Node_Type.DIVIDER]: Divider
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=nodeViewRenderers.js.map
